import React from 'react'
import {
	Stepper as MuiStepper,
	StepLabel as MuiStepLabel,
	StepIcon as MuiStepIcon,
	StepConnector as MuiStepConnector,
	Step as MuiStep,
	CircularProgress,
	Divider,
} from '@material-ui/core'
import { stepIconStyle, stepVerticalConnectorStyle, stepStyle, stepperStyle, stepHorizontalConnectorStyle, stepSecondaryLabelStyle } from './stepper.style'

export const Stepper = (props) => {
	return <MuiStepper connector={<StepConnector />} css={stepperStyle} {...props} />
}

export const StepConnector = ({ orientation, ...rest }) =>
	orientation === 'vertical' ? (
		<div css={stepVerticalConnectorStyle}>
			<Divider />
		</div>
	) : (
		<MuiStepConnector orientation={orientation} {...rest} css={stepHorizontalConnectorStyle} />
	)

export const StepIcon = (props) => (
	<div css={stepIconStyle}>
		<CircularProgress size={30} variant="static" thickness={2} value={props.active ? 100 : 0} color="inherit" />
		<MuiStepIcon {...props} />
	</div>
)

export const StepLabel = ({ variant, ...props }) => (
	<MuiStepLabel StepIconComponent={StepIcon} css={variant === 'secondary' && stepSecondaryLabelStyle} {...props} />
)

export const Step = (props) => <MuiStep css={stepStyle} {...props} />
